module.exports = __webpack_public_path__ + "img/icon-check-mark-circle.9685b558.svg";